<template>
  <div id="app">
    <Navigation />
    <div class>
      <transition name="fade" mode="out-in">
        <router-view
          class="view"
          :horoscopeData="horoscopeData"
          :tarotData="tarotData"
          :zodiacData="zodiacData"
          :loadingPage="loadingPage"
        ></router-view>
      </transition>
    </div>
    <UnsubModal/>
    <footer>
      <p class="editor">©Mobiscope {{ year }}</p>
    </footer>
    <canvas id="universe"></canvas>
    <canvas id="universeElms" height="600"></canvas>
    <canvas id="granim-canvas"></canvas>
  </div>
</template>

<script>
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "flickity/dist/flickity.min.css";
import Granim from "granim";
import EventBus from "./components/EventBus.vue";
import mobiscope from "../src/router/mobiscope";
import Navigation from "./components/mobiscope/Navigation.vue";
import Vue from "vue";
import VueRouter from "vue-router";
import axios from "axios";
import mobiscopeData from "./components/mobiscope/mobiscope-js/mobiscope";
import country_list from "./locales/country_list.json";
import { mapGetters, mapActions } from "vuex";
import AxiosPlugin from "vue-axios-cors";
import mobiscopeAPI from "./services/api/mobiscopeAPI";
import $ from "jquery";
import UnsubModal from "./components/mobiscope/UnsubModal.vue";

const proxyurl = "https://cors-anywhere.herokuapp.com/";

const URL = "https://zodiacal.herokuapp.com/";
let currentDate = new Date();
let year = currentDate.getFullYear();

Vue.use(VueRouter);
Vue.use(AxiosPlugin);

export default {
  name: "Mobiscope",
  data() {
    return {
      token: "",
      id: this.$route.params.id,
      canvasInstance: {},
      year: year,
      horoscopeData: mobiscopeData.horoscopeData,
      tarotData: mobiscopeData.tarotData,
      zodiacData: mobiscopeData.zodiacData,
      loadingPage: mobiscopeData.loadingPage,
    };
  },
  computed: mapGetters(["language", "countryCode","host_mobiscope"]),
  components: {
    Navigation,
    UnsubModal
  },
  created() {
    this.fetchTranslateCode(this.countryCode);
    this.fetchToken_mobis(this.id);
    this.getDomain_mobis(this.host_mobiscope);
    // this.getToken();
  },
  mounted() {
    
    this.initPlanets();
    this.initBgCanavs();
    this.initStarbg();

    if (this.$route.name == "Zodiac" || this.$route.name == "ZodiacDetails" || this.$route.name == "ElementsDetails") {
      this.canvasInstance.changeState("zodiac-state");
    } else if (this.$route.name == "Tarot") {
      this.canvasInstance.changeState("tarot-state");
    } else if (this.$route.name == "ChineseZodiac" || this.$route.name == "ChineseZodiacDetails") {
      this.canvasInstance.changeState("chinese-state");
    } else if (this.$route.name == "Login") {
      document.getElementsByClassName("navbar__wrap")[0].classList.add("login");
    } else {
      this.canvasInstance.changeState("default-state");
      document
        .getElementsByClassName("navbar__wrap")[0]
        .classList.remove("login");
    }
    
    let lang = this.language;
    let country_code = this.countryCode;

    if (lang != "null" && lang != null) {
      if (lang == "arabic") {
        sessionStorage.setItem("language", lang);
        this.$i18n.locale = lang;
        document.getElementsByTagName("html")[0].classList.add("ar_layout");
        this.fetchLang(lang);
      } else {
        sessionStorage.setItem("language", lang);
        this.$i18n.locale = lang;
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLang(lang);
      }
    } else {
      let country_ls = Object.keys(country_list);

      if (country_ls.includes(country_code) ) {
        let language = country_list[country_code].language;
        
        if(sessionStorage.getItem('tokenID') == 'mobis80'){
          sessionStorage.setItem("language", 'english');
          this.$i18n.locale = 'english';
          this.fetchLang('english');
        }else{
          sessionStorage.setItem("language", language);
          this.$i18n.locale = language;
          this.fetchLang(language);
        }

        if (language != "arabic") {
          document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        } else {
          document.getElementsByTagName("html")[0].classList.add("ar_layout");
        }
      } else {
        sessionStorage.setItem("language", "english");
        this.$i18n.locale = "english";
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        this.fetchLang("english");
      }
    }
  },
  methods: {
    ...mapActions(["fetchLang", "fetchTranslateCode", "fetchToken_mobis","getDomain_mobis"]),
    initBgCanavs() {
       this.canvasInstance = new Granim({
        element: "#granim-canvas",
        name: "granim",
        direction: "top-bottom",
        isPausedWhenNotInView: true,
        opacity: [1, 1],
        states: {
          "default-state": {
            gradients: [
              ["#240795", "#571eee"],
              ["#571eee", "#130361"],
            ],
            transitionSpeed: 5000,
          },
          "tarot-state": {
            gradients: [["#3c0a6f", "#f53400"]],
            transitionSpeed: 5000,
          },
          "zodiac-state": {
            gradients: [["#161b8f", "#009dcb"]],
            transitionSpeed: 5000,
          },
          "chinese-state": {
            gradients: [["#b3001c", "#e24b19"]],
            transitionSpeed: 5000,
          },
        },
      });
      this.canvasInstance.changeState("tarot-state");
    },
    initStarbg() {
      window.requestAnimationFrame =
        window.requestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.msRequestAnimationFrame;

      let starDensity = 0.216;
      let speedCoeff = 0.05;
      let width;
      let height;
      let starCount;
      let circleRadius;
      let circleCenter;
      let first = true;
      let giantColor = "180,184,240";
      let starColor = "255,255,255";
      let cometColor = "226,225,224";
      let canva = document.getElementById("universe");
      let stars = [];
      let universe;
      const img = new Image();
      windowResizeHandler();
      window.addEventListener("resize", windowResizeHandler, false);
      createUniverse();

      function createUniverse() {
        universe = canva.getContext("2d");

        for (let i = 0; i < starCount; i++) {
          stars[i] = new Star();
          stars[i].reset();
        }
        // console.log(stars[i]);
        draw();
      }
      function draw() {
        universe.clearRect(0, 0, width, height);
        let starsLength = stars.length;

        for (let i = 0; i < starsLength; i++) {
          let star = stars[i];
          star.move();
          star.fadeIn();
          star.fadeOut();
          star.draw();
        }
        window.requestAnimationFrame(draw);
      }

      function Star() {
        this.reset = function () {
          this.giant = getProbability(3);
          this.comet = this.giant || first ? false : getProbability(10);
          this.x = getRandInterval(0, width - 10);
          this.y = getRandInterval(0, height);
          this.r = getRandInterval(1.1, 2.6);
          this.dx =
            getRandInterval(speedCoeff, 6 * speedCoeff) +
            (this.comet + 1 - 1) * speedCoeff * getRandInterval(50, 120) +
            speedCoeff * 2;
          this.dy =
            getRandInterval(speedCoeff, 6 * speedCoeff) -
            (this.comet + 1 - 1) * speedCoeff * getRandInterval(0, -120);
          this.fadingOut = null;
          this.fadingIn = true;
          this.opacity = 0;
          this.opacityTresh = getRandInterval(
            0.2,
            1 - (this.comet + 1 - 1) * 0.4
          );
          this.do =
            getRandInterval(0.0005, 0.002) + (this.comet + 1 - 1) * 0.001;
        };
        this.fadeIn = function () {
          if (this.fadingIn) {
            this.fadingIn = this.opacity > this.opacityTresh ? false : true;
            this.opacity += this.do;
          }
        };
        this.fadeOut = function () {
          if (this.fadingOut) {
            this.fadingOut = this.opacity < 0 ? false : true;
            this.opacity -= this.do / 2;
            if (this.x > width || this.y < 0) {
              this.fadingOut = false;
              this.reset();
            }
          }
        };
        this.draw = function () {
          universe.beginPath();

          if (this.giant) {
            universe.fillStyle =
              "rgba(" + giantColor + "," + this.opacity + ")";
            universe.arc(this.x, this.y, 2, 0, 2 * Math.PI, false);
          } else if (this.comet) {
            universe.fillStyle =
              "rgba(" + cometColor + "," + this.opacity + ")";
            universe.arc(this.x, this.y, 1.5, 0, 2 * Math.PI, false);

            //comet tail
            for (var i = 0; i < 30; i++) {
              universe.fillStyle =
                "rgba(" +
                cometColor +
                "," +
                (this.opacity - (this.opacity / 20) * i) +
                ")";
              universe.rect(
                this.x - (this.dx / 4) * i,
                this.y - (this.dy / 4) * i - 2,
                2,
                2
              );
              universe.fill();
            }
          } else {
            universe.fillStyle = "rgba(" + starColor + "," + this.opacity + ")";
            universe.rect(this.x, this.y, this.r, this.r);
          }

          universe.closePath();
          universe.fill();
        };
        this.move = function () {
          this.x += this.dx;
          this.y += this.dy;
          if (this.fadingOut === false) {
            this.reset();
          }
          if (this.x > width - width / 4 || this.y < 0) {
            this.fadingOut = true;
          }
        };
        (function () {
          setTimeout(function () {
            first = false;
          }, 50);
        })();
      }
      function getProbability(percents) {
        return Math.floor(Math.random() * 1000) + 1 < percents * 10;
      }

      function getRandInterval(min, max) {
        return Math.random() * (max - min) + min;
      }

      function windowResizeHandler() {
        width = window.innerWidth;
        height = window.innerHeight;
        starCount = width * starDensity;
        circleRadius = width > height ? height / 2 : width / 2;
        circleCenter = {
          x: width / 2,
          y: height / 2,
        };

        canva.setAttribute("width", width);
        canva.setAttribute("height", height);
      }
    },
    initPlanets() {
      let planetCanvas = document.getElementById("universeElms");
      planetCanvas.setAttribute("width", window.innerWidth);
      // planetCanvas.setAttribute("height", window.innerHeight);
      let planetCanvasCtx = planetCanvas.getContext("2d");

      const img = new Image();
      const img2 = new Image();
      img.src = require("./assets/mobiscope/imgs/planet-left.png");
      img2.src = require("./assets/mobiscope/imgs/planet-right.png");
      img.onload = () => {
        // planetCanvasCtx.drawImage(img, 0, 0);
        if (window.innerWidth < 900) {
          planetCanvasCtx.drawImage(
            img,
            -300,
            300,
            550,
            img.height * (550 / img.width)
          );
          planetCanvasCtx.drawImage(
            img2,
            window.innerWidth - img2.width * 0.25,
            420,
            320,
            img2.height * (320 / img2.width)
          );
        } else {
          planetCanvasCtx.drawImage(
            img,
            -300,
            200,
            700,
            img.height * (700 / img.width)
          );
          planetCanvasCtx.drawImage(
            img2,
            window.innerWidth - img2.width * 0.25,
            350,
            400,
            img2.height * (400 / img2.width)
          );
        }
      };
    },
  },
  watch: {
    $route(to, from) {
      const toDepth = to.path.split("/");
      const fromDepth = from.path.split("/");
      let token = sessionStorage.getItem("tokenID");

      if (
        this.$route.name == "Zodiac" ||
        this.$route.name == "ZodiacDetails" ||
        this.$route.name == "ElementsDetails"
      ) {
        this.canvasInstance.changeState("zodiac-state");
      } else if (this.$route.name == "Tarot") {
        this.canvasInstance.changeState("tarot-state");
      } else if (
        this.$route.name == "ChineseZodiac" ||
        this.$route.name == "ChineseZodiacDetails"
      ) {
        this.canvasInstance.changeState("chinese-state");
      } else if (this.$route.name == "Login") {
        document
          .getElementsByClassName("navbar__wrap")[0]
          .classList.add("login");
      } else {
        this.canvasInstance.changeState("default-state");
        document
          .getElementsByClassName("navbar__wrap")[0]
          .classList.remove("login");
      }
    },
  },
};
</script>

<style lang="scss">
@import url("./assets/mobiscope/font/stylesheet.css");

// col vars
$body-color: red;
*,
::after,
::before {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-text-size-adjust: 100%;
}

ul {
  list-style: none;
  padding-left: 0px;
  margin: 0;
}
html {
  font-size: 14px;
  height: 100%;
}
body {
  color: #fff !important;
  // background: rgb(87, 30, 238);
  font-family: "SF Pro Display";
  font-weight: 400;
  position: relative;
}
body.granim-light {
  height: auto !important;
  min-height: 100%;
  line-height: 1.2;
}
#app {
  display: flex;
  width: 100%;
  height: auto;
  flex-wrap: wrap;
  align-items: flex-start;
  > div {
    width: 100%;
  }
}
canvas {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: -2;
  display: block;
}

.text_col {
  color: rgb(255, 255, 255) !important;
}

#universeElms {
  z-index: -1;
  height: auto;
  top: auto;
  bottom: 0;
}
#universe {
  z-index: -1;
}
.section {
  margin: 35px 0px;
  position: relative;
}
.section__content.center {
  text-align: center;
}
// typography styles
:root {
  --scale-element: 1;
  --scale-font: 1;
}
.purple {
  color: #dc00ac !important;
}
// .yellow {
//   color: #ffeb3b !important;
// }
.std__txt {
  font-size: 1.1rem;
  direction: ltr;
  text-align: justify;
}
.std__title {
  font-size: calc((3vw + 21px) * var(--scale-font));
  margin-bottom: 8px;
  line-height: 1;
}
.std__subtile {
  font-size: 1.8rem;
  margin-bottom: 15px;
  font-weight: 700;
}
.std__subtile.bdr {
  padding-bottom: 8px;
  border-bottom: 1px solid #fff;
}
.std__subtile.daily {
  text-transform: capitalize;
}
.std__subtile.sm {
  font-size: 1.2rem;
}
.std__subtile.md {
  font-size: 1.3rem;
}
.std__subtile.lg {
  font-size: 2.2rem;
}
.std__title.yellow {
  color: #e6ff30;
}
.std__subtile.neon {
  color: #00e7ff;
}
.dateStamp {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.65);
}

/*##### Arabic layout Styles#####*/
.ar_layout {
  body,
  .thumbCol__label {
    direction: rtl;
  }
  body.granim-light {
    line-height: 1.3;
  }
}
.ar_layout .siteNav__col,
.ar_layout .monthlyHoroscope__content,
.ar_layout .std__subtile,
.ar_layout .tarotLabel,
.ar_layout .rowContent {
  text-align: right;
}
.ar_layout .heroElmWrap .sumdge {
  right: auto;
  left: 0;
  transform: translateY(-50%) rotate(180deg);
}
.ar_layout .heroElmWrap .horo_image {
  right: auto;
  left: 0;
}
.ar_layout .accountInfo a {
  margin-right: 1.375rem;
  margin-left: 0 !important;
}

.ar_layout .tarotUl {
  text-align: right;
  padding-right: 0px;
  padding-left: 0px;
}
.ar_layout p {
  direction: rtl;
  text-align: justify;
}
.ar_layout .modal-header .close {
  margin: -1rem auto -1rem -1rem;
}
.ar_layout .zodiacCol .std__subtile,
.ar_layout .zodiacCol .std__txt,
.ar_layout footer p {
  text-align: center;
}
.ar_layout .section__content.center .std__subtile {
  text-align: center;
}
// form styles
.stdGroup {
  margin: 25px 0px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.25);
}
.stdBtn {
  font-weight: 500;
  box-shadow: 0px 3px 8px -1px rgba(0, 0, 0, 0.75);
  background: #dc00ac !important;
  color: #fff !important;
  font-weight: 500;
  a {
    color: #fff;
  }
}
.stdBtn.yellow {
  background: #e6ff30 !important;
  color: #c9241b !important;
}
.stdGroup--inline {
  display: inline-block;
  vertical-align: top;
  margin-right: 25px;
}

.month_wrap {
  h3 {
    color: $body-color;
    font-size: 3rem;
  }
}

//Shared elements styles
.signIcon.zodiac {
  text-align: left;
}
.signIcon {
  color: #fff;
  display: block;
  position: relative;
  margin: 15px 0px;
  cursor: pointer;
  text-align: center;
  img {
    width: 50px;
  }
  &:hover {
    color: #fff;
    text-decoration: none;
  }
  &:hover .signIcon__img {
    background: #dc00ac;
  }
  .shadow {
    content: "";
    position: absolute;
    width: 68px;
    height: 68px;
    top: 0;
    left: 0;
    margin: auto;
    right: 0;
    border-radius: 50%;
  }
}

.signIcon.yellow {
  &:hover .signIcon__img {
    background: #e6ff30;
  }
}
.signIcon.sm {
  .signIcon__img,
  .shadow {
    width: 48px;
    height: 48px;
  }
  .signIcon__label {
    font-size: 1rem;
  }
}
.signIcon__label {
  font-size: 1.3rem;
  font-weight: 600;

  margin: 5px 0px;
}

.signIcon__date {
  font-size: 1rem;
}

.signIcon__img {
  display: inline-block;
  width: 68px;
  height: 68px;
  background: #fff;
  mask-size: cover;
}
.modalCustom {
  .thumbnail {
    width: 100%;
    max-width: 100%;
    img {
      width: 100%;
    }
  }
  .std__subtile,
  p {
    color: #000;
  }
}

//Horoscope & Chinese Zodiac styles
.monthlyHoroscope {
  position: relative;
  height: 60vh;
  .container {
    position: relative;
    height: 100%;
    z-index: 3;
    display: flex;
    align-items: center;
  }
  img {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  .std__title {
    text-transform: uppercase;
  }
}
.monthlyHoroscope__content {
  max-width: 50%;
}
.horo_image {
  right: 15%;
  z-index: 2;
  width: 100%;
  max-width: 420px;
}
.sumdge {
  max-width: 580px;
  width: 100%;
  right: 0;
}
.horo_img {
  width: 100%;
}
.contentPanel {
  position: relative;
  z-index: 4;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  
  h3 {
    color: #000;
  }
}
.policy_wrap{
    background: #fff;
    border-radius: 38px 38px 38px 38px;
    padding: 25px 15px;
    min-height: 780px;
    color:black;
}
.mobiSection__content{
    padding: 25px 50px;
}
.mobiTitle {
    margin: 0;
    line-height: 1.1;
    text-transform: capitalize;
    word-break: break-word;
    color: #000;
}
.mobiTitle.sm {
    font-size: 1.2rem;
}
ul.a {
  list-style-position: outside;
}

.nav-tabs.custom {
  .nav-link {
    color: #fff;
    font-size: 1.2rem;
    font-weight: 600;
  }
  .nav-link.active {
    background: #fff;
    color: #dc00ac;
  }
}
.tab-pane {
  padding: 15px 0px;
}

.rowContent {
  margin: 15px 0px;
  span {
    font-weight: 600;
    font-size: 1.2rem;
    margin-right: 8px;
    vertical-align: middle;
  }
}
.inlineTagsWrap {
  display: inline-block;
  vertical-align: middle;
  background: rgba(255, 255, 255, 0.8);
  padding: 5px 11px;
  border-radius: 8px;
  font-size: 0;
}
.inlineTags {
  display: inline-block;
  vertical-align: middle;
  margin: 0 7px;
  img {
    width: 62px;
    margin-bottom: 8px;
  }
  a {
    display: block;
    color: #fff;
    text-align: center;
  }
}
.inlineTags.text {
  background: #fff;
  border-radius: 8px;
  div {
    color: #e80006;
    padding: 3px 10px;
    font-weight: 500;
  }
}
.symbol {
  font-size: 2.6rem;
}
//footer styles
footer {
  text-align: center;
  padding: 15px;
  //background: rgba(0, 0, 0, 0.3);
  margin-top: 35px;
  width: 100%;
  align-self: flex-end;
  p {
    margin: 0;
  }
}

//Utility  styles
.m2--topBtm {
  margin-top: 20px;
  margin-bottom: 20px;
}
//Responsive styles
@media (max-width: 991px) {
  .heroElmWrap {
    height: 180px;
    position: relative;
  }
  .monthlyHoroscope__content {
    max-width: 100%;
  }
  .monthlyHoroscope {
    height: auto;
  }
  .horo_image {
    right: 0;
  }
  .modalCustom .thumbnail {
    max-width: 320px;
    margin: 0 auto;
  }
}

@media (max-width: 479px) {
  .sumdge,
  .horo_image {
    max-width: 320px;
  }
  .signIcon {
    .shadow,
    .signIcon__img {
      width: 48px;
      height: 48px;
    }
  }
  .elementItem__icon {
    max-width: 82px;
  }
  .modalCustom .thumbnail {
    max-width: 220px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/Mobiscope.vue